import React, { useState, useRef } from 'react';
import classNames from 'classnames';
import useUserProfile from 'src/services/profile';
import useCompany from 'src/services/company';
import { useOutsideClick } from 'src/hooks/utils';
import { NavOverlay } from '../NavOverlay/NavOverlay';
import styles from './NavItemUser.module.scss';

export type NavItemUserProps = {
  expanded: boolean;
};

function getInitials(name: string): string {
  if (!name) return '';
  const parts = name.trim().split(/\s+/);
  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : '';
  return (first + last).toUpperCase();
}

export const NavItemUser: React.FC<NavItemUserProps> = ({ expanded }) => {
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const overlayRef = useRef<HTMLDivElement>(null);

  const { profile } = useUserProfile();
  const { company } = useCompany();

  const openOverlay = () => {
    setOverlayVisible(!isOverlayVisible);
  };

  const handleCloseOverlay = () => {
    setOverlayVisible(false);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target as Node)) {
      handleCloseOverlay();
    }
  };
  // register click outside event to close the menu
  useOutsideClick(overlayRef, handleOutsideClick);

  return (
    <div className={classNames(styles.root, expanded ? 'p-20 border-subtle--dark' : 'px-12 pb-12')} ref={overlayRef}>
      {isOverlayVisible && <NavOverlay expanded={expanded} onOptionSelect={handleCloseOverlay} />}
      <button onClick={openOverlay} type="button" className="flex flex-row justify-between w-full">
        <div
          className={classNames('overflow-hidden transition-all whitespace-nowrap text-left', {
            hidden: !expanded,
          })}>
          {profile.name && <div className="typo-text-14 text-full--dark mb-2">{profile.name}</div>}
          {company.name && (
            <div className="typo-text-12 text-sidebar-muted mb-2 text-wrap truncate">{company.name}</div>
          )}
          {/* {!isLoading && !error && data && ( */}
          {/*  <div className="typo-text-12 text-faded mb-2 text-wrap truncate" title={t('fulfillment_billing.netto_balance_this_month')}> */}
          {/*    {data.current_month.total_netto}{company.currency} */}
          {/*  </div> */}
          {/* )} */}
        </div>
        <div className={`${styles.avatar} bg-color-indigo-tint rounded-full`}>
          <p className="typo-text-12--bold text-color-indigo">{profile.name ? getInitials(profile.name) : ''}</p>
        </div>
      </button>
    </div>
  );
};
